/**
 * 考试的公共页面
 */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Breadcrumb, message } from 'antd';
import { getExActInfo } from "../../apis/public";
import MenuComp from '../../College/layout/Menu';
import "./index.less";

interface IProps extends RouteComponentProps {};
interface IState {
  activityId: string;
  activityInfo: any;
  showSignModal: boolean;
}


class ActivityDetail extends Component<IProps, IState> {
  state: IState = {
    activityId: "",
    activityInfo: {},
    showSignModal: false
  }

  componentDidMount() {
    console.log(this.props);
    const { params }: any = this.props.match;
    this.setState({
      activityId: params.id
    }, () => {
      this.initialData();
    })
  }
  // 获取外部用户活动详情
  initialData = () => {
    const { activityId } = this.state;
    getExActInfo({id: activityId}).then((res: any) => {
      if (res && res.code === 0) {
        const { data = {}} = res;
        this.setState({
          activityInfo: data ? data :{}
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  // 返回
  goPage = (url: string) => {
    this.props.history.push(url);
  }
  render() {
    const _types = (types: any[]) => {
      const content: any = [];
      types.forEach(item => content.push(item.type_name));
      return content.join('、');
    }
    const _tags = (tags: any[]) => {
      const content: any = [];
      tags.forEach(item => content.push(item.tag_name));
      return content.join('、');
    }
    const { activityInfo } = this.state;
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    return (
      <div className="public_exam">
        {/* <div className="public_nav">
          <div className="nav">
            <div className="logo">
              <img src={Logo} alt=""/>
            </div>
          </div>
        </div> */}
        <MenuComp userinfo={userinfo} />
        <div className="public_inner">
          <div className="inner">
            <div className="exam_detail">
              <Breadcrumb style={{marginBottom: 20}}>
                <Breadcrumb.Item onClick={this.goPage.bind(this, '/')}>
                  <span style={{cursor: 'pointer'}}>首页</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={this.goPage.bind(this, '/activity')}>
                  <span style={{cursor: 'pointer'}}>活动列表</span>
                </Breadcrumb.Item>
                <Breadcrumb.Item>活动详情</Breadcrumb.Item>
              </Breadcrumb>
              <div className="del">
                <div className="del_title">
                  {activityInfo.title}
                </div>
                <div className="del_line"></div>
                <div className="del_bas">
                  {activityInfo.types && <><span >分类：</span>{activityInfo.types && _types(activityInfo.types)}</>}
                </div>
                <div className="del_bas">{activityInfo.tags && <><span>标签：</span>{activityInfo.tags && _tags(activityInfo.tags)}</>}</div>
                {/* <div className="del_bas"><span>创建时间：</span>{moment(activityInfo.create_time * 1000).format("YYYY-MM-DD")}</div> */}
                <div className="del_bas"><span>摘要：</span>{activityInfo.abstract}</div>
                {/* <div>sdfsfddssdf</div> */}
                <div className="del_bas">
                 <span>内容：</span>
                 <div className="dels" dangerouslySetInnerHTML={{__html: activityInfo.describe}}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ActivityDetail;
